import React from "react";

/**
 * Замена цветного swagger.png: растровый логотип в чёрном тулбаре с волосяными
 * линиями был самым неуместным пикселем в интерфейсе. Моноширинные скобки
 * нарисованы контурами и наследуют currentColor — внешних запросов нет
 * (закрытый контур QA), цвет совпадает с остальными иконками.
 */
const ApiDocsIcon = (props) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    role="img"
    aria-label="API docs"
    focusable="false"
  >
    <path d="M8.5 5.5C6.5 5.5 6.5 8.4 6.5 9.6c0 1.3-.6 2.4-2 2.4 1.4 0 2 1.1 2 2.4 0 1.2 0 4.1 2 4.1" />
    <path d="M15.5 5.5c2 0 2 2.9 2 4.1 0 1.3.6 2.4 2 2.4-1.4 0-2 1.1-2 2.4 0 1.2 0 4.1-2 4.1" />
    <circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export default ApiDocsIcon;
